import React, { Fragment, useState } from 'react';
import classnames from "classnames";
import {Container, Col, Row } from "reactstrap";
import { TabMenu } from 'primereact/tabmenu';
import { IndexUnits } from '../../units/IndexUnits';
import { IndexUnitConversions } from '../../units/IndexUnitConversions';

export const IndexUnit = (props) => {


    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        { label: 'Unidades' },
        { label: 'Unidades de conversión' }
    ];


    return (
        <Fragment>
            {/* <Breadcrumb parent="Configuraciones" title="Administración de unidades" /> */}
            <Container fluid={true} style={{  scrollBehavior: "smooth" , transform: "scale(0.8)",    width: "125%",    transformOrigin: "top left" }}>
                <Row>
                    <Col sm="12">
                        <div>
                            <TabMenu 
                                model={items} 
                                activeIndex={activeIndex} 
                                onTabChange={(e) => setActiveIndex(e.index)}
                                className="custom-tabmenu-blue-report"
                            />
                        </div>
                        <div style={{ marginTop: "1rem" }}>
                            <div style={{ display: activeIndex === 0 ? "block" : "none" }}>
                                <IndexUnits {...props} />
                            </div>
                            <div style={{ display: activeIndex === 1 ? "block" : "none" }}>
                                <IndexUnitConversions {...{ ...props, }} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Fragment >
    )
}
